<template>
  <m4-modal
    ref="root_modal"
    :vertical-center="verticalCenter"
    :size="size"
    :init-show="initShow"
    :init-show-with-delay="initShowWithDelay"
    :allow-close-by-clicking-on-bg="allowCloseByClickingOnBg"
    @openModal="$emit('openModal')"
    @closeModal="$emit('closeModal')"
  >
    <template v-slot:button>
      <slot name="button"></slot>
    </template>
    <template v-if="title || rightTitle" v-slot:header>
      <span v-if="title && !rightTitle && !hasSlotRightTitle">
        {{ title }}
      </span>
      <m4-level v-else>
        <m4-level-left>
          {{ title }}
        </m4-level-left>
        <m4-level-right v-if="rightTitle">
          {{ rightTitle }}
        </m4-level-right>
        <m4-level-right v-else-if="hasSlotRightTitle">
          <slot name="rightTitle"></slot>
        </m4-level-right>
      </m4-level>
    </template>
    <template v-slot:body>
      <div class="padding-b-md padding-t-md">
        <slot></slot>
      </div>
    </template>
    <template v-if="hasSlotFooter && showFooter" v-slot:footer>
      <slot name="footer"></slot>
    </template>
    <template v-else-if="showFooter" v-slot:footer>
      <div class="text-right">
        <m4-button v-if="btnCancelTitle" size="md" @click="onCloseDialog" tag="a">{{ btnCancelTitle }}</m4-button>
        <m4-button
          v-if="newSubmitUrl || hasSubmitListener || hasSubmitAndCloseListener"
          size="md"
          @click="onSubmitDialog"
          tag="a"
          :variant="btnVariant"
          class="margin-l-lg"
        >
          {{ btnTitle }}
        </m4-button>
        <m4-button
          v-if="hasSecondSubmitListener"
          size="md"
          @click="onSecondSubmitDialog"
          tag="a"
          :variant="secondBtnVariant"
          class="margin-l-lg"
        >
          {{ secondBtnTitle }}
        </m4-button>
      </div>
    </template>
  </m4-modal>
</template>

<script>
import callExternalFunction from "../../../utils/callExternalFunction";

export default {
  name: "M4Dialog",
  mixins: [callExternalFunction],
  data() {
    return {
      newSubmitUrl: this.submitUrl
    };
  },
  props: {
    title: String,
    rightTitle: String,
    submitUrl: String,
    size: {
      type: String,
      default() {
        return "sm";
      }
    },
    btnVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    secondBtnVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    btnTitle: {
      type: String,
      default() {
        return "OK";
      }
    },
    secondBtnTitle: {
      type: String,
      default() {
        return "OK";
      }
    },
    btnCancelTitle: {
      type: String,
      default() {
        return "Cancel";
      }
    },
    initShow: {
      type: Boolean,
      default() {
        return false;
      }
    },
    initShowWithDelay: {
      type: Number,
      default() {
        return 0;
      }
    },
    closeAfterSubmit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    verticalCenter: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showFooter: {
      type: Boolean,
      default() {
        return true;
      }
    },
    allowCloseByClickingOnBg: {
      type: Boolean,
      default() {
        return true;
      }
    },
    onOnSubmitDialog: Function,
    onOnSecondSubmitDialog: Function,
    onOnSubmitDialogAndClose: Function
  },
  emits: [
    "closeModal",
    "openModal",
    "onSecondSubmitDialog",
    "onSubmitDialog",
    "onSubmitDialogAndClose",
    "onSubmitUrl",
    "onSetSubmitUrl"
  ],
  computed: {
    hasSlotFooter() {
      return typeof this.$slots.footer === "function";
    },
    hasSlotTitle() {
      return typeof this.$slots.title === "function";
    },
    hasSlotRightTitle() {
      return typeof this.$slots.rightTitle === "function";
    },
    hasSubmitListener() {
      return (
        typeof this.$props.onOnSubmitDialog === "function" ||
        typeof this.$attrs.onOnsubmitdialog === "function" ||
        (this.callExtFuncOnEmit && this.callExtFuncOnEmit["onSubmitDialog"] !== undefined)
      );
    },
    hasSecondSubmitListener() {
      return (
        typeof this.$props.onOnSecondSubmitDialog === "function" ||
        typeof this.$attrs.onOnsecondsubmitdialog === "function"
      );
    },
    hasSubmitAndCloseListener() {
      return (
        typeof this.$props.onOnSubmitDialogAndClose === "function" ||
        typeof this.$attrs.onOnsubmitdialogsndclose === "function"
      );
    }
  },
  methods: {
    setSubmitUrl(url) {
      this.newSubmitUrl = url;
      this.$emit("onSetSubmitUrl", this.newSubmitUrl);
    },
    onCloseDialog() {
      this.$refs.root_modal.onClickCloseModal();
    },
    onSubmitDialog() {
      if (this.newSubmitUrl) {
        this.$emit("onSubmitUrl");
        return (location.href = this.newSubmitUrl);
      } else {
        if (this.hasSubmitAndCloseListener) {
          this.$emit("onSubmitDialogAndClose");
          this.onCloseDialog();
          return true;
        }

        if (typeof this.$attrs.onOnsubmitdialog === "function") {
          return this.$emit("onsubmitdialog", this);
        }

        this.callExtFunc("onSubmitDialog", this);
        return this.$emit("onSubmitDialog", this);
      }
    },
    onSecondSubmitDialog() {
      return this.$emit("onSecondSubmitDialog", this);
    }
  },
  watch: {
    submitUrl(val) {
      this.newSubmitUrl = val;
    }
  }
};
</script>
